import { render } from "./ContractDistributions.vue?vue&type=template&id=7288b236"
import script from "./ContractDistributions.vue?vue&type=script&lang=js"
export * from "./ContractDistributions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__